import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { UserModel, Token } from '@kanzi-apes/kanzi-models';
import * as lcStorage from '@kanzi-apes/kanzi-utils';
import { AuthEntity } from './auth.models';
import * as AuthActions from './auth.actions';

export const AUTH_FEATURE_KEY = 'auth';

export interface AuthState extends EntityState<AuthEntity> {
  loggedIn: boolean;
  token: Token | null;
  user: UserModel | null;
  loading: boolean;
  error: any;
}

export interface AuthPartialState {
  readonly [AUTH_FEATURE_KEY]: AuthState;
}

export const authAdapter: EntityAdapter<AuthEntity> =
  createEntityAdapter<AuthEntity>();

export const initialAuthState: AuthState = authAdapter.getInitialState(
  (lcStorage.loadState() && lcStorage.loadState()['auth']) || {
    loggedIn: false,
    token: null,
    user: null,
    loading: false,
    error: null,
  }
);

const reducer = createReducer(
  initialAuthState,
  on(AuthActions.initAuth, (state) => ({
    ...state,
    loggedIn: false,
    token: null,
    user: null,
  })),
  on(AuthActions.login, (state) => ({
    ...state,
    loading: true,
  })),
  on(AuthActions.loginSuccess, (state, { token }) => ({
    ...state,
    loggedIn: true,
    token: token,
    user: null,
    loading: false,
  })),
  on(AuthActions.logout, (state) => ({
    ...state,
    loggedIn: false,
    token: null,
    user: null,
  })),
  on(AuthActions.userProfileLoad, (state) => state),
  on(AuthActions.userProfileSuccess, (state, { user }) => ({
    ...state,
    user: user,
    loggedIn: state.loggedIn,
    token: state.token,
  })),
  on(AuthActions.userLoginFailureToken, (state) => ({
    ...state,
    loggedIn: false,
    token: null,
    user: null,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    error: error,
    loading: false,
    loggedIn: false,
  }))
);

export function authReducer(state: AuthState | undefined, action: Action) {
  return reducer(state, action);
}
